import { NumericFormat } from "react-number-format";

const CaltexNumberInput = (props) => {
    return (
        <NumericFormat
            className="number-input"
            thousandSeparator=","
            value={props.value}
            onChange={props.onChange}
            decimalScale={2}
            fixedDecimalScale
            maxLength={250}
            inputMode="decimal"
        />
    );
};

export default CaltexNumberInput;
